// import {
// 	ElIcon,
// 	ElInput,
// 	ElButton,
// 	ElForm,
// 	ElFormItem,
// 	ElCheckbox,
// 	ElDialog,
// 	ElTabPane,
// 	ElTabs,
// 	ElLink,
// 	ElCascader
// } from "element-plus";
// import lang from 'element-plus/lib/locale/lang/zh-cn';
// import locale from 'element-plus/lib/locale';
// import config from '../config';
// import baseApp from '../../plugins/baseApp';
// import App from './App';
// const vm = baseApp(App, config.schoolId);
// // 设置语言
// locale.use(lang);

// vm.use(ElIcon).use(ElForm).use(ElFormItem).use(ElInput).use(ElButton).use(ElCheckbox).use(ElLink).use(ElDialog).use(ElTabPane).use(ElTabs).use(ElLink).use(ElCascader)
// vm.mount('#app');

import baseApp from '@/pages/innerAPP'
import App from './App'
;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
